module.exports = __webpack_public_path__ + "ae9767d4b8d6c2fc991c41eea6238f16.svg";